// Module
var code = `<ex-erreur-chargement class="m-t-40" retry-action="vm.retourAction()" lbl-retry="{{vm.lblRetour}}" lbl-message="{{vm.lblMessage}}"> </ex-erreur-chargement>`;
// Exports
module.exports = code;